import { coverDetailsFragment } from "@saleor/fragments/cover";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  CoverBulkDelete,
  CoverBulkDeleteVariables
} from "./types/CoverBulkDelete";
import {
  CoverCataloguesAdd,
  CoverCataloguesAddVariables
} from "./types/CoverCataloguesAdd";
import {
  CoverCataloguesRemove,
  CoverCataloguesRemoveVariables
} from "./types/CoverCataloguesRemove";
import { CoverCreate, CoverCreateVariables } from "./types/CoverCreate";
import { CoverDelete, CoverDeleteVariables } from "./types/CoverDelete";
import { CoverUpdate, CoverUpdateVariables } from "./types/CoverUpdate";

const coverDelete = gql`
  mutation CoverDelete($id: ID!) {
    coverDelete(id: $id) {
      errors: errors {
        message
      }
    }
  }
`;
export const useCoverDeleteMutation = makeMutation<
  CoverDelete,
  CoverDeleteVariables
>(coverDelete);

const coverBulkDelete = gql`
  mutation CoverBulkDelete($ids: [ID]!) {
    coverBulkDelete(ids: $ids) {
      errors: errors {
        message
      }
    }
  }
`;

export const useCoverBulkDeleteMutation = makeMutation<
  CoverBulkDelete,
  CoverBulkDeleteVariables
>(coverBulkDelete);

const coverCreate = gql`
  mutation CoverCreate($input: CoverInput!) {
    coverCreate(input: $input) {
      cover {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useCoverCreateMutation = makeMutation<
  CoverCreate,
  CoverCreateVariables
>(coverCreate);

const coverUpdate = gql`
  mutation CoverUpdate($id: ID!, $input: CoverInput!) {
    coverUpdate(id: $id, input: $input) {
      errors {
        field
        message
      }
    }
  }
`;

export const useCoverUpdateMutation = makeMutation<
  CoverUpdate,
  CoverUpdateVariables
>(coverUpdate);

const coverCataloguesRemove = gql`
  ${coverDetailsFragment}
  mutation CoverCataloguesRemove(
    $input: RangeInput!
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    coverCataloguesRemove(id: $id, input: $input) {
      errors {
        message
        field
      }
      cover {
        ...CoverDetailsFragment
      }
    }
  }
`;

export const useCoverCataloguesRemoveMutation = makeMutation<
  CoverCataloguesRemove,
  CoverCataloguesRemoveVariables
>(coverCataloguesRemove);

const coverCataloguesAdd = gql`
  ${coverDetailsFragment}
  mutation CoverCataloguesAdd(
    $input: RangeInput!
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    coverCataloguesAdd(id: $id, input: $input) {
      errors {
        message
        field
      }
      cover {
        ...CoverDetailsFragment
      }
    }
  }
`;
export const useCoverCataloguesAddMutation = makeMutation<
  CoverCataloguesAdd,
  CoverCataloguesAddVariables
>(coverCataloguesAdd);
